﻿window.info_electricconnection_hist_currenttplist = function () {    
    var _id;
    var instance = {        
        init: function (id) {
            _id = id;
        },
        delete: function (tpId) {              
                     
            var table = document.getElementById(_id +"_currenttplist")
            var deletedtp = table.querySelector('tr[data-rowid="' + tpId + '"]');

            if (deletedtp) {
                deletedtp.classList.add("crossout");
            }

        },
        remove: function (tpId) {
            
            var table = document.getElementById(_id + "_currenttplist")
            if (table) {
                var removetp = table.querySelector('tr[data-rowid="' + tpId + '"]');

                if (removetp) {
                    removetp.classList.remove("crossout");
                }
            }
        }
    }
    return instance;
}();




